<template>
  <el-dialog
    :title="$t('sign_up.title')"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-press-escape="true"
    custom-class="elsa-modal signup"
    :center="false"
    width="255"
    top="50px"
  >
    <signup-form
      ref="signupForm"
      v-bind="$attrs"
      :viaLink="viaLink"
      :viaEmail="viaEmail"
      @close="handleSignUp"
    />
    <!--
    <div class="already-has-account">
      <div class="divider"></div>
      <p>{{ $t('sign_up.already_have_an_account') }}</p>
      <secundary-button
        @click.native="()=> $emit('closed', {'handleClose': true})"
      >
        {{$t('common.login')}}
      </secundary-button>
    </div>
    -->
  </el-dialog>
</template>

<script>
import SignupForm from "@/components/common/SignupForm";
// import SecundaryButton from '@/components/common/buttons/SecundaryButton'

export default {
  components: {
    SignupForm,
    // SecundaryButton
  },

  props: {
    dialogVisible: {
      default: false,
    },
    viaLink: {
      default: false,
    },
    viaEmail: {
      default: false,
    },
    newUser: {
      default: false,
    },
  },
  methods: {
    handleClose() {
      // this.dialogVisible = false
      this.$refs.signupForm.resetForm();
      this.$emit("closed", { handleClose: true });
    },
    handleSignUp(data) {
      // this.dialogVisible = false
      const option = { handleSignUp: true };
      this.$refs.signupForm.resetForm();
      if (data) {
        this.$emit("closed", { ...data, ...option });
      } else {
        this.$emit("closed", option);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";

.elsa-modal.signup > .el-dialog__body > .already-has-account {
  margin: auto 40px;

  & > .divider {
    border-top-color: $purple;
    margin: 0px;
    padding-bottom: 40px;
  }

  p {
    font-family: "SF Pro Display", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: $darker-blue;

    margin: 0 0 16px 0;
  }
}

.el-dialog.elsa-modal .el-dialog__body > *:not(p):not(.info) {
  padding-bottom: 40px;
}
</style>
